import React from 'react';

import type { TextAdConditions } from '../../util/text-ads-util';
import { isBingEnabled } from '../initialisation-util';
import ExternallyPopulatedTag from '../../../components/externally-populated-tag';
import { BingFallback } from './components/bing-fallback';

export const BingSlotDivNames = {
    bingTop: 'bing-top',
    bingBottom: 'bing-bottom',
} as const;

export const BingSlotAttributionNames = {
    bingTopAttribution: `${BingSlotDivNames.bingTop}-attribution`,
    bingBottomAttribution: `${BingSlotDivNames.bingBottom}-attribution`,
};

export const BingSlotContainerNames = {
    top: `${BingSlotDivNames.bingTop}-container`,
    bottom: `${BingSlotDivNames.bingBottom}-container`,
};

export const BingSlotFallbackContainerNames = {
    top: `${BingSlotDivNames.bingTop}-fallback`,
    bottom: `${BingSlotDivNames.bingBottom}-fallback`,
};

export type BingSlotDivName = typeof BingSlotDivNames[keyof typeof BingSlotDivNames];

export const BingTopSlot = (textAdConditions: TextAdConditions) => {
    return isBingEnabled(textAdConditions) ? (
        <div id={BingSlotContainerNames.top} style={{ display: 'grid', margin: '8px 0 16px' }}>
            <div id={BingSlotAttributionNames.bingTopAttribution} style={{ marginLeft: '16px' }} />
            <div style={{ display: 'flex', overflowX: 'auto' }}>
                <ExternallyPopulatedTag tagId={BingSlotDivNames.bingTop} />
            </div>
            <div
                id={BingSlotFallbackContainerNames.top}
                style={{ display: 'none', width: '100%' }}
            >
                <BingFallback />
            </div>
        </div>
    ) : (
        <></>
    );
};

export const BingBottomSlot = (textAdConditions: TextAdConditions) => {
    return isBingEnabled(textAdConditions) ? (
        <div id={BingSlotContainerNames.bottom}>
            <div
                id={BingSlotAttributionNames.bingBottomAttribution}
                style={{ marginLeft: '16px' }}
            />
            <div style={{ display: 'flex', overflowX: 'auto' }}>
                <ExternallyPopulatedTag tagId={BingSlotDivNames.bingBottom} />
            </div>
            <div
                id={BingSlotFallbackContainerNames.bottom}
                style={{ display: 'none', width: '100%', height: '300px' }}
            >
                <BingFallback />
            </div>
        </div>
    ) : (
        <></>
    );
};
